module.exports = __webpack_public_path__ + "img/11_Mid-body+LC.72167e4b.png";